/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Table footer item component (new version)
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.12.0
 */

import { useCallback } from 'react';

import { ONBOARDING_DATA_ATTR } from '../../../modules/onboarding/onboardingConstants';
import { EOnboardingComponentsId } from '../../../modules/onboarding/types/onboardingTypes';
import { ImgStyled } from '../Block/Img';
import { EllipseText } from '../index';
import ArrowTooltip from '../Tooltip/Tooltip';
import { TableFooterItemStyled } from './styled/TableFooterItemStyled';

interface ITableFooterItem {
    className?: string;
    dataName: string;
    icon: string;
    isDisabled?: boolean;
    onboarding?: EOnboardingComponentsId;
    text: string;
    tooltipMsg?: string;

    onClick: () => void;
}

const TableFooterItem = ({
                             className,
                             dataName,
                             icon,
                             isDisabled,
                             onboarding,
                             text,
                             tooltipMsg,

                             onClick,
                         }: ITableFooterItem) => {

    const onClickHandler = useCallback(() => {
        if (isDisabled) return;

        onClick();
    }, [isDisabled, onClick]);

    return (
        <ArrowTooltip
            // Tooltip is displayed when the button is locked
            disableHoverListener={!tooltipMsg || !isDisabled}
            key={text}
            placement="top"
            title={tooltipMsg || ''}
            titleAlign="center"
        >
            <TableFooterItemStyled
                className={className + ` ${isDisabled ? 'disabled' : ''}`}
                data-table-footer-item={dataName}
                onClick={onClickHandler}
            >
                <div
                    className="table-footer__footer-item-container"
                    {...{ [ONBOARDING_DATA_ATTR]: onboarding }}
                >
                    <ImgStyled className="small" src={icon}/>
                    <EllipseText showTooltipOnOverflow={!tooltipMsg || !isDisabled} title={text}>{text}</EllipseText>
                </div>
            </TableFooterItemStyled>
        </ArrowTooltip>
    );
};

export default TableFooterItem;
